import { createUseExternalEvents as mantineCreateUseExternalEvents } from '@mantine/core';

export const createUseExternalEvents = mantineCreateUseExternalEvents;
